import { useTranslation } from 'react-i18next';

/**
 * `useTranslation` bound to the `tv` + `common` namespaces so that `t('tv:…')` and
 * `t('common:…')` are both type-checked against the bundled resources (WP0.3 typing).
 */
export function useT() {
  return useTranslation(['tv', 'common']);
}
